const namespaced = true

const state = {
  coinDistributionSetting: {}
}

const mutations = {
  setOverrideCoinDistributionSetting (state, data) {
    state.coinDistributionSetting = data.coinDistributionSetting
  }
}

const getters = {
  getOverrideCoinDistributionSetting: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideCoinDistributionSetting.js